import { useQuery } from "@tanstack/react-query";
import { fetchCartingPersonel } from "../api/fetchCartingPersonel";

export const useCartingPersonel = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["cartingPersonel"],
    queryFn: fetchCartingPersonel,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

